module.exports = __webpack_public_path__ + "763af1bb41194851c51cf41af3438b36.svg";